import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

import { JSONStringify, ParseQueryType } from 'zigra-ng-framework';
import {
    DigitalClientCardType,
    DigitalClientCardTypeQuery,
    InvoiceType
} from '../zigra-schema.autogenerated.models';

@Injectable()
export class PostDCLsToAADESchema {
    //private schemaEndPoint = 'https://localhost:7043/graphql/Authorized/Solutions';
    protected entityName: string = 'PostDCLsToAADE';
    protected schemaEndPoint = `${environment.graphQLEndPoint}/Authorized/PostDCLsToAADE`;

    constructor(protected http: HttpClient) {}

    public NewDigitalClientCard(
        digitalClientCard: DigitalClientCardType,
        query: DigitalClientCardTypeQuery
    ) {
        const sQuery = `mutation NewDigitalClientCard {
            NewDigitalClientCard(DigitalClientCard: ${JSONStringify(digitalClientCard)}) 
             { ${ParseQueryType<DigitalClientCardTypeQuery>(query)} }  
        }`;

        return this.http.post<{
            data: { NewDigitalClientCard: DigitalClientCardType | undefined };
        }>(this.schemaEndPoint, {
            query: sQuery
        });
    }

    public UpdateDigitalClientCard(
        digitalClientCard: DigitalClientCardType,
        query: DigitalClientCardTypeQuery
    ) {
        const sQuery = `mutation UpdateDigitalClientCard {
            UpdateDigitalClientCard(DigitalClientCard: ${JSONStringify(digitalClientCard)}) 
             { ${ParseQueryType<DigitalClientCardTypeQuery>(query)} }  
        }`;

        return this.http.post<{
            data: {
                UpdateDigitalClientCard: DigitalClientCardType | undefined;
            };
        }>(this.schemaEndPoint, {
            query: sQuery
        });
    }

    public CorrelateDigitalClientCard(
        digitalClientCard: DigitalClientCardType | undefined,
        invoice: InvoiceType | undefined,
        query: DigitalClientCardTypeQuery
    ) {
        const sQuery = `mutation CorrelateDigitalClientCard {
            CorrelateDigitalClientCard(DigitalClientCard: ${JSONStringify(digitalClientCard)}, Invoice: ${JSONStringify(invoice)}) 
             { ${ParseQueryType<DigitalClientCardTypeQuery>(query)} }  
        }`;

        return this.http.post<{
            data: {
                CorrelateDigitalClientCard: DigitalClientCardType | undefined;
            };
        }>(this.schemaEndPoint, {
            query: sQuery
        });
    }
}
